
import InitiationHeader from './InitiationHeader';

interface ErrorPanelProps {
  errorMessage: string;
}

const ErrorPanel = ({ errorMessage }: ErrorPanelProps) => {
  return (
    <div className="max-w-3xl mx-auto w-full">
      <InitiationHeader />
      <div className="bg-navy-light p-8 rounded-lg border border-tan-dark">
        <div className="text-center space-y-6">
          <h2 className="text-2xl font-patrick mb-4 text-red-500">Connection Error</h2>
          <p className="text-lg">{errorMessage}</p>
          <button 
            onClick={() => window.location.reload()}
            className="bg-tan text-navy hover:bg-tan-dark mt-6 px-6 py-3 rounded-lg"
          >
            Retry Connection
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPanel;
